module.exports = __webpack_public_path__ + "img/img49.88f3a6e0.svg";